import "./styles/lcars.css";
import { initApp } from "./ui/app";
import { handleRedirectIfNeeded } from "./services/storage";

async function boot(): Promise<void> {
  const appEl = document.getElementById("app");
  if (!appEl) return;

  try {
    // Complete OAuth redirect (if returning from Microsoft login)
    await handleRedirectIfNeeded();
  } catch (err) {
    console.error("Auth redirect error:", err);
  }

  await initApp(appEl);
}

boot();
